"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transactionApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var transactionApi = exports.transactionApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/transaction",
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/transaction",
      data: data,
      method: "post"
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/transaction/".concat(id),
      method: "patch",
      data: data
    });
  },
  delete: function _delete(id) {
    return (0, _request.default)({
      url: "/transaction/".concat(id),
      method: "delete"
    });
  }
};